import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export const useApp = () => {
	const context = useContext(AppContext);
	if (!context) {
		throw new Error('useApp must be used within an AppProvider');
	}
	return context;
};

export const AppProvider = ({ children }) => {
	const [activeSection, setActiveSection] = useState('Dashboard');
	const [isCollapsed, setIsCollapsed] = useState(true);
	const [selectedLink, setSelectedLink] = useState('');
	const [messages, setMessages] = useState([]);
	const [unreadCount, setUnreadCount] = useState(0);
	const [inboxMessages, setInboxMessages] = useState(null);
	const [autoApplyData, setAutoApplyData] = useState(null);

	const value = {
		activeSection,
		setActiveSection,
		isCollapsed,
		setIsCollapsed,
		selectedLink,
		setSelectedLink,
		messages,
		setMessages,
		unreadCount,
		setUnreadCount,
		autoApplyData,
		setAutoApplyData,
		inboxMessages,
		setInboxMessages,
	};

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
